import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

export default function TooltipText({ children, vText="", className="", positionType = "center", customOffset = 0 }) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const refChild = useRef(null);
  const refTooltip = useRef(null);

  useEffect(() => {
    if (visible && refChild.current) {
      const rect = refChild.current.getBoundingClientRect();
      let leftPosition;

      switch (positionType) {
        case "left":
          leftPosition = rect.left;
          break;
        case "right":
          leftPosition = rect.left + rect.width;
          break;
        case "custom":
          leftPosition = rect.left + customOffset;
          break;
        case "center":
        default:
          leftPosition = rect.left + rect.width / 2;
          break;
      }

      setPosition({
        top: rect.top - 35, // Ajusta según tu diseño
        left: leftPosition,
      });
    }
  }, [visible, positionType, customOffset]);

  return (
    <>
      <div
        ref={refChild}
        className={`${className}`}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>

      {visible && vText.length > 0 &&
        ReactDOM.createPortal(
          <span
            ref={refTooltip}
            className="tooltiptext-portal"
            style={{ top: `${position.top}px`, left: `${position.left}px` }}
          >
            {vText}
          </span>,
          document.body
        )}
    </>
  );
}
